/*
 * Artisan Roast - "Send as a gift" (simple version, no dispatch date)
 * Product page: adds a gift panel (message + recipient email) to the add-to-cart form of eligible products.
 * Cart: shows a gift notice and warns about mixed baskets or subscriptions.
 * Gift details travel on the order as line item properties: Gift, Gift message, Gift recipient email.
 */
(function () {
  if (window.arGiftInit) { return; }
  window.arGiftInit = true;

  var cfg = window.arGift || {};
  var FLAG = 'Gift', MSG = 'Gift message', MAIL = 'Gift recipient email';
  var root = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
  var N_DELIVERY = 'At checkout, enter the recipient’s name and address under Delivery, and your own under Billing.';
  var N_BASKET = 'Everything in one order goes to the same person. Buying for yourself too? Please place a separate order.';
  var M_INFO = 'This order is a gift. At checkout, enter the recipient’s name and address under Delivery, and your own under Billing. Everything in this basket goes to the recipient.';
  var M_MIXED = 'Your basket has a gift and other items. Everything in one order goes to the same address. Please remove the gift, or place a separate order for yourself.';
  var M_SUB = 'Gifts can’t be sent as subscriptions. Please switch the gift back to a one-off purchase.';

  var css =
    '.ar-gift{margin:0 0 16px;padding:14px 16px;border:1px solid rgba(0,0,0,.2);border-radius:0}' +
    '.ar-gift[hidden],.ar-gift__fields[hidden]{display:none}' +
    '.ar-gift__toggle{display:flex;align-items:center;gap:10px;margin:0;cursor:pointer;font-weight:600}' +
    '.ar-gift__toggle input{margin:0;width:18px;height:18px;border-radius:0!important}' +
    '.ar-gift__fields{margin-top:12px;display:flex;flex-direction:column;gap:6px}' +
    '.ar-gift__fields label{font-size:.9em;margin:6px 0 0}' +
    '.ar-gift__fields textarea,.ar-gift__fields input{width:100%;font:inherit;padding:10px 12px;border:1px solid rgba(0,0,0,.25);border-radius:0;background:transparent;color:inherit;box-sizing:border-box}' +
    '.ar-gift__hint{margin:4px 0 0;font-size:.8em;opacity:.75;line-height:1.4}' +
    '.ar-gift-notice{margin:0 0 16px;padding:12px 14px;border-radius:6px;font-size:.9em;line-height:1.45;background:rgba(0,0,0,.05)}' +
    '.ar-gift-notice[data-kind=warn]{background:#fff4e5;border:1px solid #d9a05b}' +
    '.ar-gift-line .ar-sub{display:none}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function el(tag, attrs, text) {
    var n = document.createElement(tag);
    if (attrs) { for (var k in attrs) { n.setAttribute(k, attrs[k]); } }
    if (text) { n.textContent = text; }
    return n;
  }

  /* ---------- Product page panel ---------- */

  function buildPanel() {
    var uid = 'ar-gift-' + Math.random().toString(36).slice(2, 8);
    var wrap = el('div', { 'class': 'ar-gift', 'data-ar-gift-panel': '' });
    var toggle = el('label', { 'class': 'ar-gift__toggle' });
    toggle.appendChild(el('input', { type: 'checkbox', 'data-ar-gift-check': '' }));
    toggle.appendChild(el('span', null, 'Send as a gift'));
    var fields = el('div', { 'class': 'ar-gift__fields', hidden: '', 'data-ar-gift-fields': '' });
    fields.appendChild(el('label', { 'for': uid + '-msg' }, 'Gift message'));
    fields.appendChild(el('textarea', { id: uid + '-msg', name: 'properties[' + MSG + ']', rows: '4', maxlength: '300', placeholder: 'Your message to the recipient', 'data-ar-gift-msg': '', disabled: '' }));
    fields.appendChild(el('label', { 'for': uid + '-mail' }, 'Recipient’s email'));
    fields.appendChild(el('input', { type: 'email', id: uid + '-mail', name: 'properties[' + MAIL + ']', placeholder: 'name@example.com', autocomplete: 'off', 'data-ar-gift-mail': '', disabled: '' }));
    fields.appendChild(el('p', { 'class': 'ar-gift__hint' }, 'We email them when the gift is on its way, with your message and no prices.'));
    fields.appendChild(el('p', { 'class': 'ar-gift__hint' }, N_DELIVERY));
    fields.appendChild(el('p', { 'class': 'ar-gift__hint' }, N_BASKET));
    wrap.appendChild(toggle);
    wrap.appendChild(fields);
    wrap.appendChild(el('input', { type: 'hidden', name: 'properties[' + FLAG + ']', value: 'Yes', 'data-ar-gift-flag': '', disabled: '' }));
    return wrap;
  }

  function sync(form) {
    var wrap = form.querySelector('[data-ar-gift-panel]');
    if (!wrap) { return; }
    var sp = form.elements ? form.elements.namedItem('selling_plan') : null;
    var isSub = !!(sp && sp.value);
    wrap.hidden = isSub;
    var on = !isSub && wrap.querySelector('[data-ar-gift-check]').checked;
    wrap.querySelector('[data-ar-gift-fields]').hidden = !on;
    ['data-ar-gift-flag', 'data-ar-gift-msg', 'data-ar-gift-mail'].forEach(function (a) {
      wrap.querySelector('[' + a + ']').disabled = !on;
    });
    wrap.querySelector('[data-ar-gift-mail]').required = on;
  }

  function syncAll() {
    var forms = document.querySelectorAll('form[data-ar-gift]');
    for (var i = 0; i < forms.length; i++) { sync(forms[i]); }
  }

  function valid(form) {
    var wrap = form.querySelector('[data-ar-gift-panel]');
    if (!wrap || wrap.hidden || !wrap.querySelector('[data-ar-gift-check]').checked) { return true; }
    var mail = wrap.querySelector('[data-ar-gift-mail]');
    if (mail.value.trim() && mail.checkValidity()) { return true; }
    mail.reportValidity();
    return false;
  }

  function mount() {
    if (!cfg.eligible) { return; }
    var ids = (cfg.variantIds || []).map(String);
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      if (form.hasAttribute('data-ar-gift')) { continue; }
      var v = form.querySelector('[name=id]');
      if (!v || ids.indexOf(String(v.value)) === -1) { continue; }
      var btn = form.querySelector('[type=submit], [name=add]');
      if (!btn || !btn.parentNode) { continue; }
      form.setAttribute('data-ar-gift', '');
      btn.parentNode.insertBefore(buildPanel(), btn);
      var guard = (function (f) {
        return function (e) {
          if (!valid(f)) { e.preventDefault(); e.stopImmediatePropagation(); }
        };
      })(form);
      btn.addEventListener('click', guard, true);
      form.addEventListener('submit', guard, true);
      sync(form);
    }
  }

  document.addEventListener('change', function () { setTimeout(syncAll, 0); });
  document.addEventListener('click', function () { setTimeout(syncAll, 0); });

  /* ---------- Cart notice ---------- */

  function cartPass() {
    var els = document.querySelectorAll('[data-cart-item][data-item]');
    if (!els.length) { return; }
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    }).then(function (cart) {
      var gift = {}, hasGift = false, hasOther = false, hasSub = false;
      (cart.items || []).forEach(function (i) {
        if (i.properties && i.properties[FLAG]) {
          gift[i.key] = true;
          hasGift = true;
          if (i.selling_plan_allocation) { hasSub = true; }
        } else {
          hasOther = true;
        }
      });
      var msg = '', kind = '';
      if (hasGift && hasSub) { msg = M_SUB; kind = 'warn'; }
      else if (hasGift && hasOther) { msg = M_MIXED; kind = 'warn'; }
      else if (hasGift) { msg = M_INFO; kind = 'info'; }
      var seen = [];
      for (var i = 0; i < els.length; i++) {
        els[i].classList.toggle('ar-gift-line', !!gift[els[i].getAttribute('data-item')]);
        var holder = els[i].parentNode;
        if (seen.indexOf(holder) > -1) { continue; }
        seen.push(holder);
        var note = holder.querySelector(':scope > .ar-gift-notice');
        if (!msg) { if (note) { note.remove(); } continue; }
        if (note && note.getAttribute('data-kind') === kind && note.textContent === msg) { continue; }
        if (!note) {
          note = el('p', { 'class': 'ar-gift-notice' });
          holder.insertBefore(note, holder.firstChild);
        }
        note.setAttribute('data-kind', kind);
        note.textContent = msg;
      }
    }).catch(function () {});
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { mount(); cartPass(); }, 80);
  }
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();

  /* Subscription widgets set the selling plan by script without firing events, so re-check twice a second. */
  setInterval(syncAll, 500);
})();
